// extracted by mini-css-extract-plugin
export default {"user":"index_user_SgB9F","h_mainNavNew":"index_h_mainNavNew_s3lJ6","h_searchDiv":"index_h_searchDiv_iRP7g","h_theLogo":"index_h_theLogo_5AEJ-"};